/** @jsxRuntime automatic */
import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "./utils";
import { controlBase, controlSizes, type ControlSize } from "./control";

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "size"> {
  /** Classes for the wrapper (width, margin). `className` styles the `<select>`. */
  wrapperClassName?: string;
  /** Height, the same scale as Input and Button (components-15). */
  size?: ControlSize;
}

/**
 * Native `<select>` with the Input skin: no browser chevron (`appearance-none`),
 * our own 16 px chevron, same height as Input. Native keeps the OS picker on
 * phones, which is what people expect there.
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, wrapperClassName, size = "default", children, ...props }, ref) => (
    <div className={cn("relative w-full", wrapperClassName)}>
      <select
        ref={ref}
        className={cn(controlBase, controlSizes[size], "cursor-pointer appearance-none pr-9", className)}
        {...props}
      >
        {children}
      </select>
      <svg
        className="pointer-events-none absolute right-3 top-1/2 size-4 -translate-y-1/2 text-subtle-foreground"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </div>
  ),
);
Select.displayName = "Select";
